export default $axios => ({
    getPageContent(slug) {
        return $axios({
            method: 'GET',
            url: `/page/${slug}/`
        });
    }
});
